export default {"src":"/_next/static/image/public/images/icons3/4.ae20dc01d16b8ff7aa1ce0153aa850a2.svg","height":72,"width":72};